/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import PatientSymptomAttribute from './patient-symptom-attribute';
import PatientSymptomAttributeDetail from './patient-symptom-attribute-detail';
import PatientSymptomAttributeUpdate from './patient-symptom-attribute-update';
import PatientSymptomAttributeDeleteDialog from './patient-symptom-attribute-delete-dialog';

const PatientSymptomAttributeRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<PatientSymptomAttribute />} />
    <Route path="new" element={<PatientSymptomAttributeUpdate />} />
    <Route path=":id">
      <Route index element={<PatientSymptomAttributeDetail />} />
      <Route path="edit" element={<PatientSymptomAttributeUpdate />} />
      <Route path="delete" element={<PatientSymptomAttributeDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default PatientSymptomAttributeRoutes;
